import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import '../styles/NotificationsDashboard.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const NotificationsDashboard = () => {
  // Doughnut Chart Data
  const doughnutData = {
    labels: ['Unread', 'Important', 'System', 'Invoices', 'Payments', 'Others'],
    datasets: [{
      data: [8, 5, 24, 32, 18, 37],
      backgroundColor: ['#3b82f6', '#ef4444', '#22c55e', '#a855f7', '#f59e0b', '#848a95'],
      borderWidth: 0,
      cutout: '72%',
    }],
  };

  const donutOptions = {
    plugins: { legend: { display: false }, tooltip: { enabled: true } },
    maintainAspectRatio: false,
  };

  // Mock Data for Notifications List
  const notifications = [
    { id: 1, title: "New Invoice Created", sub: "Invoice INV-2025-158 has been created for Green Mart.", icon: "fa-solid fa-file-invoice", color: "purple", type: "Invoices", date: "20 May 2025", time: "11:45 AM", unread: true },
    { id: 2, title: "Payment Received", sub: "Payment of ₹45,000 received from Acme Corp.", icon: "fa-solid fa-indian-rupee-sign", color: "green", type: "Payments", date: "20 May 2025", time: "10:30 AM", unread: true },
    { id: 3, title: "Low Stock Alert", sub: "5 products are running low on stock.", icon: "fa-solid fa-triangle-exclamation", color: "orange", type: "Inventory", date: "20 May 2025", time: "09:15 AM", unread: true },
    { id: 4, title: "GSTR-3B Due Soon", sub: "Your GSTR-3B for Apr 2025 is due on 20 May 2025.", icon: "fa-regular fa-calendar", color: "red", type: "GST & Tax", date: "20 May 2025", time: "08:00 AM", unread: true },
    { id: 5, title: "New Customer Registered", sub: "John Doe has registered as a new customer.", icon: "fa-solid fa-user-plus", color: "teal", type: "Customers", date: "19 May 2025", time: "04:20 PM", unread: false },
    { id: 6, title: "Special Offer Activated", sub: "Summer Sale offer is now live for all customers.", icon: "fa-solid fa-gift", color: "purple", type: "Marketing", date: "19 May 2025", time: "02:10 PM", unread: false },
    { id: 7, title: "Backup Completed", sub: "Your data backup has been completed successfully.", icon: "fa-solid fa-cloud-arrow-down", color: "green", type: "System", date: "19 May 2025", time: "01:05 PM", unread: false },
    { id: 8, title: "Expense Added", sub: "Office Rent expense of ₹25,000 has been added.", icon: "fa-regular fa-credit-card", color: "orange", type: "Expenses", date: "19 May 2025", time: "11:50 AM", unread: false },
    { id: 9, title: "Subscription Renewal Reminder", sub: "Your Pro Plan will renew on 25 May 2025.", icon: "fa-regular fa-bell", color: "teal", type: "Subscription", date: "19 May 2025", time: "10:30 AM", unread: false },
    { id: 10, title: "Monthly Report Ready", sub: "Your business summary report for Apr 2025 is ready.", icon: "fa-solid fa-chart-line", color: "red", type: "Reports", date: "18 May 2025", time: "07:30 PM", unread: false }
  ];

  // Mock Data for Recent Important
  const recentImportant = [
    { title: "GSTR-3B Due Soon", sub: "Due date: 20 May 2025", icon: "fa-regular fa-calendar", color: "red", time: "08:00 AM" },
    { title: "Low Stock Alert", sub: "5 products are low in stock", icon: "fa-solid fa-triangle-exclamation", color: "orange", time: "09:15 AM" },
    { title: "Overdue Invoices", sub: "3 invoices are overdue", icon: "fa-solid fa-file-invoice", color: "purple", time: "Yesterday" },
    { title: "Payment Failed", sub: "Payment of ₹12,500 failed", icon: "fa-solid fa-shield-halved", color: "green", time: "18 May 2025" },
    { title: "Subscription Expiring", sub: "Your plan expires in 7 days", icon: "fa-solid fa-user-lock", color: "blue", time: "16 May 2025" }
  ];

  return (
    <div className="notif-wrapper">
      
      {/* 1. Top KPI Grid */}
      <div className="notif-kpi-grid">
        <div className="notif-card notif-kpi-card">
          <div className="notif-icon-box notif-bg-purple-light"><i className="fa-regular fa-bell notif-text-purple"></i></div>
          <div className="notif-kpi-info">
            <span className="notif-kpi-title">All Notifications</span>
            <h2 className="notif-kpi-value">124</h2>
            <div className="notif-kpi-meta">All Unread & Read</div>
          </div>
        </div>
        <div className="notif-card notif-kpi-card">
          <div className="notif-icon-box notif-bg-green-light"><i className="fa-regular fa-envelope notif-text-green"></i></div>
          <div className="notif-kpi-info">
            <span className="notif-kpi-title">Unread</span>
            <h2 className="notif-kpi-value">8</h2>
            <div className="notif-kpi-meta">Pending Notifications</div>
          </div>
        </div>
        <div className="notif-card notif-kpi-card">
          <div className="notif-icon-box notif-bg-orange-light"><i className="fa-solid fa-circle-info notif-text-orange"></i></div>
          <div className="notif-kpi-info">
            <span className="notif-kpi-title">Important</span>
            <h2 className="notif-kpi-value">5</h2>
            <div className="notif-kpi-meta">Requires Attention</div>
          </div>
        </div>
        <div className="notif-card notif-kpi-card">
          <div className="notif-icon-box notif-bg-blue-light"><i className="fa-regular fa-calendar notif-text-blue"></i></div>
          <div className="notif-kpi-info">
            <span className="notif-kpi-title">This Week</span>
            <h2 className="notif-kpi-value">32</h2>
            <div className="notif-kpi-meta">01 May - 07 May 2025</div>
          </div>
        </div>
        <div className="notif-card notif-kpi-card">
          <div className="notif-icon-box notif-bg-red-light"><i className="fa-regular fa-calendar-check notif-text-red"></i></div>
          <div className="notif-kpi-info">
            <span className="notif-kpi-title">This Month</span>
            <h2 className="notif-kpi-value">78</h2>
            <div className="notif-kpi-meta">May 2025</div>
          </div>
        </div>
      </div>

      {/* 2. Main Layout */}
      <div className="notif-main-layout">
        
        {/* Left Column: Notifications List */}
        <div className="notif-left-col">
          <div className="notif-card notif-p-0">
            
            {/* Toolbar */}
            <div className="notif-toolbar">
              <div className="notif-tabs">
                <div className="notif-tab active">All</div>
                <div className="notif-tab">Unread</div>
                <div className="notif-tab">Important</div>
                <div className="notif-tab">System</div>
                <div className="notif-tab">Invoices</div>
                <div className="notif-tab">Payments</div>
                <div className="notif-tab">Reminders</div>
                <div className="notif-tab">Offers</div>
              </div>
              <div className="notif-actions">
                <button className="notif-btn-outline"><i className="fa-solid fa-check-double"></i> Mark all as read</button>
                <button className="notif-btn-outline"><i className="fa-solid fa-filter"></i> Filter <i className="fa-solid fa-chevron-down notif-ml-4"></i></button>
              </div>
            </div>

            {/* List Table */}
            <div className="notif-table-wrapper">
              <table className="notif-table">
                <thead>
                  <tr>
                    <th className="notif-cb-col"><input type="checkbox" /></th>
                    <th>Notification</th>
                    <th>Type</th>
                    <th>Date & Time</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {notifications.map((row) => (
                    <tr key={row.id}>
                      <td className="notif-cb-col"><input type="checkbox" /></td>
                      <td>
                        <div className="notif-cell-main">
                          <div className={`notif-icon-sm notif-bg-${row.color}-light notif-text-${row.color}`}><i className={row.icon}></i></div>
                          <div className="notif-text-content">
                            <strong className="notif-fw-600">{row.title}</strong>
                            <span className="notif-text-muted">{row.sub}</span>
                          </div>
                        </div>
                      </td>
                      <td><span className={`notif-badge notif-badge-${row.color}`}>{row.type}</span></td>
                      <td>
                        <div className="notif-datetime">
                          <span className="notif-fw-500">{row.date}</span>
                          <span className="notif-text-muted notif-text-xs">{row.time}</span>
                        </div>
                      </td>
                      <td className="notif-dot-col">{row.unread && <span className="notif-unread-dot"></span>}</td>
                      <td className="notif-action-col"><button className="notif-icon-btn"><i className="fa-solid fa-ellipsis-vertical"></i></button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="notif-pagination">
              <span className="notif-page-info">Showing 1 to 10 of 124 notifications</span>
              <div className="notif-page-controls">
                <button className="notif-page-btn"><i className="fa-solid fa-chevron-left"></i></button>
                <button className="notif-page-btn notif-page-active">1</button>
                <button className="notif-page-btn">2</button>
                <button className="notif-page-btn">3</button>
                <button className="notif-page-btn">4</button>
                <button className="notif-page-btn">5</button>
                <span className="notif-page-dots">...</span>
                <button className="notif-page-btn">13</button>
                <button className="notif-page-btn"><i className="fa-solid fa-chevron-right"></i></button>
              </div>
              <div className="notif-page-size">
                Show <select defaultValue="10"><option value="10">10</option></select> per page
              </div>
            </div>

          </div>
        </div>

        {/* Right Column */}
        <div className="notif-right-col">
          
          {/* Notification Summary Donut */}
          <div className="notif-card notif-p-24">
            <h3 className="notif-card-title notif-mb-20">Notification Summary</h3>
            <div className="notif-donut-layout">
              <div className="notif-donut-wrapper">
                <Doughnut data={doughnutData} options={donutOptions} />
                <div className="notif-donut-center">
                  <span className="notif-dc-label">Total</span>
                  <strong className="notif-dc-value">124</strong>
                </div>
              </div>
              <div className="notif-donut-legend">
                <div className="notif-leg-item"><span className="notif-dot notif-bg-blue"></span><div><strong>Unread</strong><span>8 (6.5%)</span></div></div>
                <div className="notif-leg-item"><span className="notif-dot notif-bg-red"></span><div><strong>Important</strong><span>5 (4.0%)</span></div></div>
                <div className="notif-leg-item"><span className="notif-dot notif-bg-green"></span><div><strong>System</strong><span>24 (19.4%)</span></div></div>
                <div className="notif-leg-item"><span className="notif-dot notif-bg-purple"></span><div><strong>Invoices</strong><span>32 (25.8%)</span></div></div>
                <div className="notif-leg-item"><span className="notif-dot notif-bg-orange"></span><div><strong>Payments</strong><span>18 (14.5%)</span></div></div>
                <div className="notif-leg-item"><span className="notif-dot notif-bg-gray"></span><div><strong>Others</strong><span>37 (29.8%)</span></div></div>
              </div>
            </div>
          </div>

          {/* Recent Important Notifications */}
          <div className="notif-card notif-p-24">
            <div className="notif-card-header">
              <h3 className="notif-card-title">Recent Important Notifications</h3>
              <a href="#" className="notif-link">View All</a>
            </div>
            <div className="notif-recent-list">
              {recentImportant.map((item, i) => (
                <div className="notif-recent-item" key={i}>
                  <div className={`notif-icon-sm notif-bg-${item.color}-light notif-text-${item.color}`}><i className={item.icon}></i></div>
                  <div className="notif-recent-text">
                    <strong className="notif-fw-600">{item.title}</strong>
                    <span className="notif-text-muted notif-text-xs">{item.sub}</span>
                  </div>
                  <div className="notif-recent-time">{item.time}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Notification Settings */}
          <div className="notif-card notif-p-24">
            <h3 className="notif-card-title notif-mb-20">Notification Settings</h3>
            <div className="notif-settings-list">
              
              <div className="notif-setting-item">
                <div className="notif-icon-sm notif-bg-gray-light notif-text-gray"><i className="fa-regular fa-envelope"></i></div>
                <div className="notif-setting-text">
                  <strong className="notif-fw-600">Email Notifications</strong>
                  <span className="notif-text-muted notif-text-xs">Receive notifications on your email</span>
                </div>
                <label className="notif-switch">
                  <input type="checkbox" defaultChecked />
                  <span className="notif-slider"></span>
                </label>
              </div>

              <div className="notif-setting-item">
                <div className="notif-icon-sm notif-bg-gray-light notif-text-gray"><i className="fa-regular fa-bell"></i></div>
                <div className="notif-setting-text">
                  <strong className="notif-fw-600">Browser Notifications</strong>
                  <span className="notif-text-muted notif-text-xs">Show notifications in browser</span>
                </div>
                <label className="notif-switch">
                  <input type="checkbox" defaultChecked />
                  <span className="notif-slider"></span>
                </label>
              </div>

              <div className="notif-setting-item">
                <div className="notif-icon-sm notif-bg-gray-light notif-text-gray"><i className="fa-solid fa-volume-high"></i></div>
                <div className="notif-setting-text">
                  <strong className="notif-fw-600">Sound Alerts</strong>
                  <span className="notif-text-muted notif-text-xs">Play sound for new notifications</span>
                </div>
                <label className="notif-switch">
                  <input type="checkbox" />
                  <span className="notif-slider"></span>
                </label>
              </div>

            </div>
            <div className="notif-mt-20">
              <a href="#" className="notif-link">Manage Notification Preferences <i className="fa-solid fa-arrow-right"></i></a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default NotificationsDashboard;